import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {Dialog, CardContent, Typography, Grid, Slide} from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import {securedFetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import * as Sentry from '@sentry/react';
import {useRecoilValue} from 'recoil';
import {userState} from '../../recoil/user/userAtom';
import {lastMsgState} from '../../recoil/socket/socketAtom';
import NotificationMenuHeader from './components/NotificationMenuHeader';
import makeStyles from '@mui/styles/makeStyles';
import Notifications from './components/Notifications';
import {IUserResponse} from '@bidmii/common/lib/server/IServerApi';
import PrimaryButton from '../../common/StyledComponents/PrimaryButton';
import BidmiiTooltip from '../../common/StyledComponents/BidmiiTooltip';
import moment from 'moment';
import useScreenWidth from '../../hooks/useScreenWidth';
import StandardDialog from '../../common/StyledComponents/StandardDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children?: ReactNode; direction: "down"; r... Remove this comment to see the full error message
  return <Slide direction="down" ref={ref} {...props} />;
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(theme: Theme) => { root: { padd... Remove this comment to see the full error message
const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    marginRight: 8,
    '& > *': {
      margin: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
      position: 'absolute',
    },
  },
  notificationMenu: {
    width: '100%',
    position: 'absolute !important',
    top: window.outerWidth > 600 ? '-32px !important' : 'initial',
    bottom: 'auto',
    right: window.outerWidth > 600 ? 220 : undefined,
    borderBottom: `1px solid ${theme.palette.gray.border}`,
    borderBottomLeftRadius: window.outerWidth > 600 ? 20 : 0,
    borderBottomRightRadius: window.outerWidth > 600 ? 20 : 0,
    maxWidth: 475,
    marginRight: window.outerWidth > 600 ? 32 : 0,
  },
}));

function NotificationMenu() {
  const history = useHistory();
  const classes = useStyles();
  const width = useScreenWidth();
  const [notificationMenuOpen, setNotificationMenuOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const user = useRecoilValue(userState);
  const lastMsg = useRecoilValue(lastMsgState);

  const [notifications, setNotifications] = useState([]);
  const [lastMsgSync, setLastMsgSync] = useState<any>(null);

  const countUnreadNotifications = () => {
    let counter = 0;
    if (notifications != null && Array.isArray(notifications)) {
      notifications.forEach((notification) => {
        if (!(notification as $TSFixMe).hasBeenRead) {
          counter++;
        }
      });
    }
    return counter;
  };

  const toggleMenuOpen = () => {
    setNotificationMenuOpen(!notificationMenuOpen);
  };

  const getNotifications = () => {
    const url = (user as IUserResponse)._links.notifications.href;
    setLastMsgSync(moment());
    securedFetchRequest(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      priority: 'low',
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(
            `Server error: [${res.status}] [${res.statusText}] [${res.url}]`,
          );
        }
        return res.json();
      })
      .then((res) => {
        if (res._embedded) {
          setNotifications(res._embedded.models);
        }
      })
      .catch((error) => {
        process.env.NODE_ENV === 'development' && console.error(error);

        Sentry.withScope(function (scope) {
          scope.setUser({
            uid: user.uid,
            firstName: user.firstName,
          });
          scope.setTag('section', 'notification_menu');
          Sentry.captureException(error);
        });
      });
  };

  const handleRedirect = (action: $TSFixMe) => {
    setDialogOpen(false);
    if (action !== 'close') {
      history.push(action);
    }
  };

  const evaluateLastMsgActions = (messageList: $TSFixMe) => {
    try {
      for (let x = 0; x < messageList.length; x++) {
        const msg = messageList[x];
        if (['proposal_funded', 'badge'].includes(msg.type)) {
          setDialogData({...JSON.parse(msg.data), type: msg.type});
          setDialogOpen(true);
        }
      }
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  useEffect(() => {
    if (
      user.uid &&
      (!(window as $TSFixMe).ReactNativeWebview ||
        process.env.REACT_APP_FORCE_WEB_VIEW === '1')
    ) {
      const minAgo = moment().diff(lastMsgSync || moment(), 'minutes');
      if (minAgo > 5 || !lastMsgSync) {
        getNotifications();
      }
      evaluateLastMsgActions(lastMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, lastMsg, lastMsgSync]);

  return (
    <div>
      <BidmiiTooltip title="Notications">
        <IconButton
          className={(classes as $TSFixMe).root}
          onClick={toggleMenuOpen}
          aria-label="recipe"
          size="large">
          <Badge
            overlap="rectangular"
            badgeContent={countUnreadNotifications()}
            color="error"
            max={99}>
            <NotificationsOutlinedIcon color="primary" />
          </Badge>
        </IconButton>
      </BidmiiTooltip>
      <Dialog
        open={notificationMenuOpen}
        onClose={toggleMenuOpen}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardRefExoticComponent<RefAttributes<unkn... Remove this comment to see the full error message
        TransitionComponent={Transition}
        PaperProps={{
          className: (classes as $TSFixMe).notificationMenu,
        }}
        fullScreen={width < 600}
        fullWidth={width < 600}
        maxWidth="xs"
        slotProps={{backdrop: {style: {backgroundColor: 'rgba(0,0,0,0.1)'}}}}>
        <NotificationMenuHeader
          notifications={notifications}
          setNotifications={setNotifications}
          closeDialog={() => setNotificationMenuOpen(false)}
        />
        <Notifications
          notifications={notifications}
          setNotifications={setNotifications}
          onClose={toggleMenuOpen}
          getNotifications={getNotifications}
        />
      </Dialog>

      <StandardDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <Grid container direction="column" alignItems="center">
          <CardContent>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{textTransform: 'uppercase', textAlign: 'center'}}>
              {(dialogData as $TSFixMe).title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {(dialogData as $TSFixMe).body}
            </Typography>
          </CardContent>
          <img
            style={{
              width: (dialogData as $TSFixMe).type === 'badge' ? 200 : '80%',
              margin: '-8px 16px',
            }}
            src={(dialogData as $TSFixMe).imgUrl}
            alt={(dialogData as $TSFixMe).title}
          />
          <CardContent>
            <PrimaryButton
              onClick={() => handleRedirect((dialogData as $TSFixMe).action)}>
              {(dialogData as $TSFixMe).buttonText
                ? (dialogData as $TSFixMe).buttonText
                : 'OK'}
            </PrimaryButton>
          </CardContent>
        </Grid>
      </StandardDialog>
    </div>
  );
}

export default NotificationMenu;
